const LANG = {
    
}
export default LANG; 